module.exports = __webpack_public_path__ + "static/media/bdjobs-android-app-logo.d7245c79.svg";